import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { gateway } from '../../../utils/api';
import showToast from '../../../utils/showToast';
import Timeline from '../../LitAtomicComponents/Contents/Timeline';
import LoadingBar from '../../LitAtomicComponents/basicComponents/LoadingBar';
import { checkIsVertibular } from '../../../utils/functions';

const STORAGE_DESTINATION_AWS = 'aws';

// Wrapper funcional para o LoadingBar
const LoadingBarWrapper = React.memo(({ loadingProgress }) => {
  return <LoadingBar loadingProgress={loadingProgress} />;
});

const Tabs = styled.ul`
  padding: 0;
`;

const TabContent = styled.div`
  background: transparent;
  border-top: none;

  #timeline {
    background-color: transparent !important;
    height: auto !important;
  }

  #comentarios span.block-light {
    padding-top: 20px !important;
  }
`;

const Infinite = styled.div`
  .infinite-scroll-component {
    max-height: 60vh;
  }
`;


function ExtraContent({ selected, playerPosition }) {
  const [isSocialUser, setSocialUser] = useState(true);
  const [isDoubts, setDoubts] = useState(false);
  const [communications, setCommunications] = useState([]);
  const [communicationsPage, setCommunicationsPage] = useState(1);
  const [interationsModalIsOpen, setInterationsModalIsOpen] = useState(false);
  const [reactionsTypes] = useState([]);
  const [hasMoreCommunications, setHasMoreCommunications] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [contentCode, setContentCode] = useState(null);
  const isAbout = useMemo(() => {
    if (selected && selected.tags && selected.tags.length > 0) {
      return selected.tags.includes('ABOUT');
    }
    return false;
  }, [selected]);

  const saveFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mediaType', file.type.toUpperCase());
    formData.append('storageDestination', STORAGE_DESTINATION_AWS);
    const response = await gateway.post('/media/media/upload', formData);
    return _.get(response, 'ox_standard.ox_identification.cr_code', null);
  };

  const loadMoreCommunications = async (page = communicationsPage) => {
    try {
      setContentCode(selected.code);
      setLoadingProgress(50);
      setIsLoading(true);

      const response = await gateway.get(
        `/webbff/lit_app_web/social/getCommunications/${selected.code}?page=${page}&limit=10`
      );

      setCommunicationsPage(communicationsPage + 1);
      setHasMoreCommunications(_.get(response, 'hasNextPage', false));

      if (page <= 1) setCommunications(_.get(response, 'docs', []));
      else setCommunications([...communications, ..._.get(response, 'docs', [])]);

      setLoadingProgress(100);
      setIsLoading(false);
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
    }
  };

  const loadCommunicationReactions = async (communicationCode) => {
    try {
      setLoadingProgress(50);
      setIsLoading(true);
      const response = await gateway.get(
        `/webbff/lit_app_web/social/getCommunicationReactions/${communicationCode}`
      );
      setLoadingProgress(100);
      setIsLoading(false);
      return response;
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
    }
  };

  const loadReactionPeople = async (communicationCode, reactionType, page = 1, limit = 10) => {
    try {
      setLoadingProgress(50);
      setIsLoading(true);
      const response = await gateway.get(
        `/webbff/lit_app_web/social/getReactionPeople/${communicationCode}/${reactionType}?page=${page}&page=${limit}`
      );
      setLoadingProgress(100);
      setIsLoading(false);
      return response;
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
    }
  };

  const createPost = async (content, files) => {
    try {
      if (!selected.code) {
        return showToast({ message: 'Selecione um conteúdo para fazer o comentário' }, true);
      }

      setLoadingProgress(50);
      setIsLoading(true);

      if (selected.type === 'VIDEO' && selected.typeContent === 'VIDEO') {
        content = `<${playerPosition}>${content}`;
      }

      const attachs = [];
      const filePromises = files.map(saveFile);
      const savedFileCodes = await Promise.all(filePromises);
      
      savedFileCodes.forEach(code => {
        if (code) attachs.push({ code });
      });

      const body = {
        destination: 'CONTENT',
        content,
        attachs,
        code: selected.code
      };

      const response = await gateway.post(
        `/webbff/lit_app_web/social/createCommunicationFromCourse`,
        body
      );

      setCommunications(_.get(response, 'docs', []));
      showToast(response);
      setLoadingProgress(100);
      setIsLoading(false);
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
      showToast(error, true);
    }
  };

  const createComment = async (content, postCode, files) => {
    try {
      setLoadingProgress(50);
      setIsLoading(true);

      if (selected.type === 'VIDEO' && selected.typeContent === 'VIDEO') {
        content = `<${playerPosition}>${content}`;
      }

      const attachs = [];
      const filePromises = files.map(saveFile);
      const savedFileCodes = await Promise.all(filePromises);
      
      savedFileCodes.forEach(code => {
        if (code) attachs.push({ code });
      });

      const body = {
        destination: 'CONTENT',
        content,
        attachs,
        parentId: postCode,
        code: selected.code
      };

      const response = await gateway.post(
        `/webbff/lit_app_web/social/createCommunicationFromCourse`,
        body
      );

      setCommunications(_.get(response, 'docs', []));
      showToast(response);
      setLoadingProgress(100);
      setIsLoading(false);
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
      showToast(error, true);
    }
  };

  const updatePost = async (content, communicationId, files, removedFiles) => {
    try {
      setLoadingProgress(50);
      setIsLoading(true);
      const toInsert = [];

      const filePromises = files.map(saveFile);
      const savedFileCodes = await Promise.all(filePromises);
      
      savedFileCodes.forEach(code => {
        if (code) toInsert.push({ code });
      });

      const body = {
        attachs: {
          toInsert,
          toDelete: removedFiles
        },
        content,
        communicationId,
        organizationCode: selected.code
      };

      const response = await gateway.put(
        `/webbff/lit_app_web/social/updateCommunication`,
        body
      );

      setCommunications(_.get(response, 'docs', []));

      setLoadingProgress(100);
      setIsLoading(false);
      showToast(response);
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
      showToast(error, true);
    }
  }

  const deleteCommunication = async (communicationId) => {
    try {
      setLoadingProgress(50);
      setIsLoading(true);

      const body = {
        communicationId,
        organizationCode: selected.code
      };

      const response = await gateway.post(
        `/webbff/lit_app_web/social/deleteCommunication`,
        body
      );

      setCommunications(_.get(response, 'docs', []));
      setLoadingProgress(100);
      setIsLoading(false);
      showToast(response);
    } catch (error) {
      setLoadingProgress(100);
      setIsLoading(false);
      showToast(error, true);
    }
  };

  useEffect(() => {
    const socialUser = JSON.parse(localStorage.getItem('socialUser'));
    if (!socialUser) {
      setSocialUser(false);
    }
  }, []);

  useEffect(() => {
    if (selected.code && contentCode !== selected.code) {
      const page = 1;
      loadMoreCommunications(page);
    }
  }, [selected.code, contentCode]);

  const isVestibular = checkIsVertibular();

  if(isVestibular) {
    return <></>
  }

  return (
    <div className="col-lg-4">
      <LoadingBarWrapper loadingProgress={loadingProgress} />
      <Tabs
        className="nav nav-tabs border-0 nav-fill"
        role="tablist"
        style={{ padding: 0 }}
      >
        <li style={{ flex: '1 1 ' }} className="nav-item">
          <a
            onClick={() => setDoubts(false)}
            href="#comentarios"
            className="nav-link border-0 active block-sobre"
            role="tab"
            data-toggle="tab"
          >
            <i className="fa fa-comment" />
            <br />
            <span className="white-space-pre"> Anotações</span>
          </a>
        </li>
      </Tabs>

      <TabContent className="tab-content">
        <div className="tab-pane active" id="comentarios" role="tabpanel">
          <Infinite>
            <Timeline
              group={{
                name: '',
                code: ''
              }}
              isContentPage
              communications={communications}
              interationsModalIsOpen={interationsModalIsOpen}
              setInterationsModalIsOpen={setInterationsModalIsOpen}
              loadMoreCommunications={loadMoreCommunications}
              loadCommunicationReactions={loadCommunicationReactions}
              loadReactionPeople={loadReactionPeople}
              updatePost={updatePost}
              createComment={createComment}
              createPost={createPost}
              reactionsTypes={reactionsTypes}
              updateCommunicationReactions={() => console.log('updateCommunicationReactions')}
              deleteCommunication={deleteCommunication}
              hasMoreCommunications={hasMoreCommunications}
              isLoading={isLoading}
              showTimer={
                selected &&
                selected.type === 'VIDEO' &&
                selected.typeContent === 'VIDEO'
              }
            />
          </Infinite>
          {isAbout && (
            <div style={{ padding: '15px' }}>
              <p style={{ fontSize: 15, textAlign: 'center' }}>
                Nenhuma disciplina selecionada!
              </p>
            </div>
          )}
        </div>
        {isSocialUser && (
          <div className="tab-pane bg-white" id="duvidas" role="tabpanel">
            {isAbout && (
              <div style={{ padding: '15px' }}>
                <p style={{ fontSize: 15, textAlign: 'center' }}>
                  Nenhuma disciplina selecionada!
                </p>
              </div>
            )}
          </div>
        )}
      </TabContent>
    </div>
  );
}

export default ExtraContent; 
